import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "pb-10 pb-lg-12" }
const _hoisted_3 = { class: "fw-bolder text-dark" }
const _hoisted_4 = { class: "text-gray-400 fw-bold fs-6" }
const _hoisted_5 = {
  key: 0,
  class: "row mb-2 d-flex justify-content-center"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "payment_select",
  class: "form-label"
}, "Account type", -1)
const _hoisted_7 = { class: "row mb-10" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_UserCreateDropdown = _resolveComponent("UserCreateDropdown")!
  const _component_UserCreateDatepicker = _resolveComponent("UserCreateDatepicker")!
  const _component_UserCreateToggle = _resolveComponent("UserCreateToggle")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.title.title), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.title.subText), 1)
    ]),
    _createVNode(_component_Form, {
      "validation-schema": _ctx.validationSchema,
      onSubmit: _ctx.handleNextStep
    }, {
      default: _withCtx(() => [
        (_ctx.lastStep && _ctx.isAtPaymentSettings)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_component_el_select, {
                onChange: _ctx.handleChangePaymentField,
                modelValue: _ctx.paymentAccount,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.paymentAccount) = $event)),
                id: "payment_select",
                placeholder: "Select payment settings",
                size: "large",
                clearable: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "I have tax ID",
                    value: "TAXID"
                  }),
                  _createVNode(_component_el_option, {
                    label: "I have danish bank account",
                    value: "danish"
                  })
                ]),
                _: 1
              }, 8, ["onChange", "modelValue"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields.fields, (field) => {
            return (_openBlock(), _createElementBlock("div", {
              key: field,
              class: _normalizeClass((field.classNames ? field.classNames : '') + (field.isHidden ? '' : ' mt-3 mb-3'))
            }, [
              (field.type == 'text')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("label", {
                      class: _normalizeClass(["form-label", field.required ? 'required' : ''])
                    }, _toDisplayString(field.label), 3),
                    _createVNode(_component_Field, {
                      placeholder: `Enter ${field.label}`,
                      name: field.key,
                      modelValue: _ctx.data[field.key],
                      class: "form-control form-control-lg form-control-solid",
                      onChange: event => _ctx.handleChange(event.target.value, field.key)
                    }, null, 8, ["placeholder", "name", "modelValue", "onChange"]),
                    _createVNode(_component_ErrorMessage, {
                      name: field.key,
                      class: "fv-plugins-message-container invalid-feedback"
                    }, null, 8, ["name"])
                  ]))
                : (field.type == 'select')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _withDirectives(_createElementVNode("label", {
                        class: _normalizeClass(["form-label", field.required ? 'required' : ''])
                      }, _toDisplayString(field.label), 3), [
                        [_vShow, !field.isHidden]
                      ]),
                      _withDirectives(_createVNode(_component_UserCreateDropdown, {
                        initialValue: _ctx.data[field.key],
                        data: field,
                        onChanged: event => _ctx.handleChange(event.value, event.field),
                        onClearvalue: _ctx.handleClear
                      }, null, 8, ["initialValue", "data", "onChanged", "onClearvalue"]), [
                        [_vShow, !field.isHidden]
                      ])
                    ]))
                  : (field.type == 'date')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("label", {
                          class: _normalizeClass(["form-label", field.required ? 'required' : ''])
                        }, _toDisplayString(field.label), 3),
                        _createVNode(_component_UserCreateDatepicker, {
                          initialValue: _ctx.data[field.key],
                          data: field,
                          onChanged: data => _ctx.handleChange(data.value, data.field)
                        }, null, 8, ["initialValue", "data", "onChanged"])
                      ]))
                    : (field.type == 'toggle')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createVNode(_component_UserCreateToggle, {
                            class: "ms-4",
                            data: field,
                            initialValue: _ctx.data[field.key],
                            onChanged: data => _ctx.handleChange(data.value, data.field)
                          }, null, 8, ["data", "initialValue", "onChanged"])
                        ]))
                      : _createCommentVNode("", true)
            ], 2))
          }), 128)),
          _withDirectives(_createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.validate && _ctx.validate(...args))),
            ref: "submitButton"
          }, null, 512), [
            [_vShow, false]
          ])
        ])
      ]),
      _: 1
    }, 8, ["validation-schema", "onSubmit"])
  ]))
}